import React from "react";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS, BRANDS } from "@/lib/site";

export default function Testimonials() {
  return (
    <section
      id="recensioni"
      data-testid="testimonials-section"
      className="relative bg-[#080808] py-24 lg:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-px bg-[#E63946]" />
              <span className="text-xs uppercase tracking-[0.3em] font-mono text-[#E63946]">
                / 05 — Recensioni
              </span>
            </div>
            <h2 className="font-heading font-black leading-[0.9] tracking-tighter text-5xl md:text-6xl">
              Cosa dicono
              <br />
              <span className="text-zinc-500">i nostri clienti.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-zinc-400 leading-relaxed">
              La soddisfazione di chi ci sceglie è la migliore garanzia
              dell'affidabilità dei nostri ricambi e della professionalità del
              nostro supporto tecnico.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 mb-20">
          {TESTIMONIALS.map((t, idx) => (
            <div
              key={t.name}
              data-testid={`testimonial-${idx}`}
              className="relative bg-[#0e0e0e] hover:bg-[#141414] p-8 lg:p-10 lift group border-l-2 border-[#E63946]/0 hover:border-[#E63946] transition-all duration-300"
            >
              <Quote
                size={36}
                className="text-[#E63946]/30 group-hover:text-[#E63946]/70 transition-colors mb-5"
                strokeWidth={1.6}
              />
              <p className="text-zinc-200 text-base md:text-lg leading-relaxed mb-8">
                {t.quote}
              </p>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#E63946] flex items-center justify-center font-heading font-black text-white">
                    {t.initials}
                  </div>
                  <div>
                    <div className="font-heading font-bold text-white">
                      {t.name}
                    </div>
                    <div className="text-xs uppercase tracking-widest text-zinc-500 font-mono">
                      {t.role}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                      key={i}
                      size={14}
                      className="text-[#E63946] fill-[#E63946]"
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Brand strip */}
        <div className="border-t border-b border-white/10 py-8 overflow-hidden">
          <div className="text-xs uppercase tracking-[0.3em] font-mono text-zinc-500 mb-6 text-center">
            Compatibile con i principali marchi
          </div>
          <div className="flex overflow-hidden">
            <div className="flex scroll-x gap-12 lg:gap-16 whitespace-nowrap">
              {[...BRANDS, ...BRANDS].map((b, i) => (
                <span
                  key={i}
                  className="font-heading font-black text-2xl md:text-3xl text-zinc-700 hover:text-white transition-colors tracking-tight"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
